import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/login/logo.png'
import _imports_1 from '@/assets/img/phone.png'
import _imports_2 from '@/assets/img/password.png'
import _imports_3 from '@/assets/img/close.png'
import _imports_4 from '@/assets/img/login/bg.png'


const _withScopeId = n => (_pushScopeId("data-v-443c6faf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "login-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo",
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "login-title" }, [
    /*#__PURE__*/_createTextVNode("欢迎使用，"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("智能投保系统。 ")
  ])
], -1))
const _hoisted_5 = { class: "login-form" }
const _hoisted_6 = { class: "form" }
const _hoisted_7 = { class: "input-block" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-icon-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "input-icon",
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_9 = { class: "input-block" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-icon-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "input-icon",
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_11 = { class: "input-opt-block" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("登录")
const _hoisted_14 = {
  key: 1,
  class: "login-qrcode"
}
const _hoisted_15 = { class: "login-qrcode-close" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "login-qrcode-name" }, "微信登陆", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-qrcode-box" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "login-qrcode-tip" }, [
  /*#__PURE__*/_createTextVNode("使用微信扫一扫登录"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("「优米雇主」")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "beian" }, [
  /*#__PURE__*/_createTextVNode(" ICP备案号："),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://beian.miit.gov.cn/"
  }, "鲁ICP备2022035489号-2")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "login-bg-img",
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.isWechat)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.phone,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phone) = $event)),
                    placeholder: "请输入手机号"
                  }, null, 8, ["modelValue"]),
                  _hoisted_8
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.code,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.code) = $event)),
                    onKeyup: _withKeys(_ctx.submit, ["enter"]),
                    placeholder: "请输入验证码"
                  }, null, 8, ["modelValue", "onKeyup"]),
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.time)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.time) + "s", 1))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "link",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getSms && _ctx.getSms(...args)))
                        }, "获取验证码"))
                  ])
                ]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "btn",
                  disabled: !(_ctx.phone && _ctx.code),
                  round: "",
                  onClick: _ctx.submit
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("img", {
                src: _imports_3,
                class: "png close",
                alt: "",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isWechat = false))
              })
            ]),
            _hoisted_16,
            _hoisted_17,
            _hoisted_18
          ])),
      _hoisted_19
    ]),
    _hoisted_20
  ]))
}